export let mainProjects = [
	{
		title: 'Next-JS JSnews Blog',
		urlRepository: 'https://github.com/ahoymarcus/nextjs-myjs-tech-blog',
		urlApp: 'https://nextjs-myjs-tech-blog.vercel.app/',
		image: '/images/frontend/nextjs-myjs-tech-blog-01.png',
		description: 'My personal blog with articles and informations about Development, specilly the technologies related to the Web and with JavaScript, React-JS, Node-JS, and the rest of its stack.',
		tags: ['react-js', 'next-js', 'gray-matter', 'remark', 'remark-html', 'date-fns'],
	},{
		title: 'Rocket Launches App',
		urlRepository: 'https://github.com/ahoymarcus/reactjs-rocket-launches-app',
		urlApp: 'https://reactjs-rocket-launches-app.netlify.app/',
		image: '/images/frontend/reactjs-rocket-launches-app.png',
		description: 'Este React app foi escrito para ser cliente de uma API que por sua vez consome seua dados de outra API externa, limitando o serviço final a apenas 04 rotas.',
		tags: ['react-js', 'use-context', 'react-router-dom', 'react-icons', 'styled-components', 'api rest'],
	},
	{
		title: 'Rocket Launches API',
		urlRepository: 'https://github.com/ahoymarcus/expressjs-rocket-launches-api',
		urlApp: '',
		image: '/images/backend/nodejs-rocket-launches-api.png',
		description: 'A API consome dados de uma API externa, a API da SpaceX REST API para criar um pequeno serviço de dados, na forma de uma api rest local com só 04 rotas.',
		tags: ['node-js', 'jwt'],
	},
    {
		title: 'My JavaScript Bookshelf',
		urlRepository: 'https://github.com/ahoymarcus/my-javascript-bookshelf',
		urlApp: 'https://my-javascript-bookshelf.netlify.app/',
		image: '/images/frontend/myjavascript-bookshelf-01.png',
		description: 'My personal project for building a book library entirely with JavaScript. In this first part, it starts with the UML modeling of core features and designing the Wireframe and the Layout pages with Figma framework. Besides, it has the basic UI and functionalities ready.',
		tags: ['html', 'css', 'css-patterns', 'javascript', 'js forms validation', 'webpack', 'babel', 'figma', 'mvc pattern'],
	},
	{
		title: 'Musica Erudita',
		urlRepository: 'https://github.com/ahoymarcus/musica-erudita',
		urlApp: 'https://musica-erudita.netlify.app/',
		image: '/images/web-design/mus-erudita-icon-bigger-page.png',
		description: 'Meu site pessoal de estudo Web Design: páginas responsivas, padrão “mobile-first”, SASS Modular, css-Grid, SVG-Animation (ver 2.0)',
		tags: ['html', 'css', 'javascript', 'sass', 'svg-animation'],
	},
	{
		title: 'jwt Exercise Studyapp',
		urlRepository: 'https://github.com/ahoymarcus/nodejs-jwt-basics-studyapp',
		urlApp: '',
		image: '/images/backend/jwt-basics-studyapp-freecodecamp.org.png',
		description: 'Uma aplicação de estudo para treinar o padrão de autenticação JSON Web Token (jwt), uma importante parte dentro do desenvolvimento de aplicações web quanto ao quesito de segurança.',
		tags: ['node-js', 'jwt', 'express-async-errors', 'dotenv', 'mongodb'],
	},
	{
		title: 'Timestamp Microservice',
		urlRepository: 'https://github.com/ahoymarcus/nodejs-timestamp-app-freecodecamp',
		urlApp: '',
		image: '/images/backend/timestamp-microservice-rodando-no-Replit.png',
		description: 'Prieiro desafio da série para a certificação Back End Development and APIs, com o objetivo de produzir uma aplicação backend que recebe requisições com parâmetros de datas para serem parseados.',
		tags: ['node-js'],
	},
	{
		title: 'URL Shortener - node-js',
		urlRepository: 'https://github.com/ahoymarcus/nodejs-url-shortener-freecodecamp',
		urlApp: '',
		image: '/images/backend/url-shortener-microservice-rodando-no-Replit.png',
		description: 'Terceiro desafio para a certificação Back End Development. De um lado recebe um payload URL e devolve uma referência mais curta. Do outro lado, redireciona para a URL quando recebe um GET com  a URL encurtada.',
		tags: ['express-js'],
	},
	{
		title: 'File Metadata Uploader',
		urlRepository: 'https://github.com/ahoymarcus/filemetadata-microservice-freecodecamp',
		urlApp: '',
		image: '/images/backend/file-metadata-microservice-home-page.png',
		description: 'Quinto desafio da certificação Back End Development, com o objetivo de produzir uma aplicação que recebe arquivos de upload e responde a requisição devolvendo informações de metadados sobre o arquivo do upload.',
		tags: ['express-js'],
	},
	{
		title: 'Exercise Tracker',
		urlRepository: 'https://github.com/ahoymarcus/nodejs-exercise-tracker-freecodecamp',
		urlApp: '',
		image: '/images/backend/exercice-tracker-microservice-home-page-comp-page.png',
		description: 'Quarto desafio da certificação Back End Development, com o objetivo de produzir uma aplicação que cadastra um usuário e pelo id-hash criado permite postar exercícios na aplicação.',
		tags: ['node-js', 'typescript'],
	},
	{
		title: 'Request Header Parser',
		urlRepository: 'https://github.com/ahoymarcus/nodejs-request-header-parser-freecodecamp',
		urlApp: '',
		image: '/images/backend/header-parser-microservice-rodando-no-Replit.png',
		description: 'Segundo desafio da série para a certificação Back End Development, com  uma aplicação que faz o parse da requisição e retornar informações da aplicação cliente.',
		tags: ['express-js'],
	},
    {
		title: 'Odin JavaScript Calculator',
		urlRepository: 'https://github.com/ahoymarcus/odin-calculator-projetct',
		urlApp: 'https://ahoymarcus.github.io/odin-calculator-projetct/',
		image: '/images/frontend/odin-javascript-calculator-project-01.png',
		description: 'This is the fifth project from The Odin Project and the third one from the JavaScript section. It aims to create a JavaScript web calculator app.',
		tags: ['html', 'css', 'css-patterns', 'javascript', 'regex'],
	},
	{
		title: 'Tribure Page',
		urlRepository: 'https://github.com/ahoymarcus/tribute-page-freecodecamp',
		urlApp: 'https://tribute-page-bach-freecodecamp.netlify.app/',
		image: '/images/web-design/tribure-page-icon-complete-page.png',
		description: 'Projeto da certificação Web Design da Frecodecamp.org de 300hs. Trata-se do design de uma página web com o intento de fazer tributo a pessoas célebres.',
		tags: ['html', 'css'],
	},
	{
		title: 'Technical Documentation Clone Page',
		urlRepository: 'https://github.com/ahoymarcus/technical-documentation-page-freecodecamp',
		urlApp: 'https://technical-mongodb-mockup-doc-page-freecodecamp.netlify.app/',
		image: '/images/web-design/technical-page-icon-bigger-page.png',
		description: 'Projeto da certificação Web Design da Frecodecamp.org de 300hs. Trata-se do desafio de clonar páginas web conhecidas. No caso deste projeto, foi clonada uma página de documentação do banco de dados MongoDB.',
		tags: ['html', 'css'],
	}
];



